import React, { useContext, useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Spin } from 'antd';
import queryString from 'query-string';
import { AppContext } from 'context/AppContext';
import { getMyMarketplaceSubscriptions } from '../apps/owner-reporting/api/marketplace';
import { buildOwnerReportingV1RedirectTo, shouldHideV1OwnerPages, shouldRedirectV1Host } from './ownerReportingReplacesV1';

const OwnerReportingV1RedirectInner = ({ location, children }) => {
  const { getUserHosts, checkIsAdmin } = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const isAdmin = !!(checkIsAdmin && checkIsAdmin());
        const userHostIds = (getUserHosts && getUserHosts()) || [];
        const parsed = queryString.parse((location && location.search) || '');
        const rawHost = parsed.host || parsed.hostId;
        const queryHost = Array.isArray(rawHost) ? rawHost[0] : rawHost;
        const pathname = (location && location.pathname) || '';

        // Platform admins keep v1 pages so they can inspect any host account.
        // Per-host v2 redirect is for host staff only.
        if (isAdmin) {
          if (!cancelled) {
            setRedirectTo(null);
            setReady(true);
          }
          return;
        }

        const mine = await getMyMarketplaceSubscriptions();
        const subscriptions = Array.isArray(mine) ? mine : [];

        if (queryHost && shouldRedirectV1Host({ hostId: queryHost, subscriptions, isAdmin })) {
          if (!cancelled) {
            setRedirectTo(buildOwnerReportingV1RedirectTo({ pathname, hostId: queryHost }));
            setReady(true);
          }
          return;
        }

        if (shouldHideV1OwnerPages({ userHostIds, subscriptions, isAdmin })) {
          if (!cancelled) {
            setRedirectTo(buildOwnerReportingV1RedirectTo({ pathname, hostId: queryHost || userHostIds[0] }));
            setReady(true);
          }
          return;
        }
      } catch (e) {
        // Fail open: keep v1 pages if the subscription check cannot run.
      }

      if (!cancelled) {
        setRedirectTo(null);
        setReady(true);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [location && location.pathname, location && location.search, getUserHosts, checkIsAdmin]);

  if (!ready) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return children;
};

const OwnerReportingV1Redirect = withRouter(OwnerReportingV1RedirectInner);

export const withOwnerReportingV1Redirect = Component => {
  const Wrapped = props => (
    <OwnerReportingV1Redirect>
      <Component {...props} />
    </OwnerReportingV1Redirect>
  );
  Wrapped.displayName = `withOwnerReportingV1Redirect(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};

export default OwnerReportingV1Redirect;
